import { z } from 'zod';

export const verifySchema = z.object({
  email: z
    .string({ error: 'Email is required' })
    .email('Enter the email you used to sign up'),
  code: z
    .string({ error: 'Verification code is required' })
    .regex(/^\d{6}$/, 'Enter the 6-digit code from your email'),
});

export type VerifySchema = z.infer<typeof verifySchema>;

export const resendVerificationSchema = z.object({
  email: z.string({ error: 'Email is required' }).email('Enter a valid email'),
});

export type ResendVerificationSchema = z.infer<typeof resendVerificationSchema>;
